import { createTheme } from '@mui/material/styles';

export const colors = {
  grey: '#222',
  mediumGrey: '#666666',
  disabledGrey: '#D3D3D3',
  borderGrey: '#E5E5E5',
  checkboxGrey: '#A0A0A0',
  lightGrey: '#f8f9fd',
  iconBlack: '#33333354',
  primaryDisabled: '#ADE2DF',
  backgroundPrimary: '#07C8C020',
  backgroundOpportunity: '#EBFBFA',
  background: '#F7F8FB',
  inactiveRed: '#F32424',
  error: '#F32424',
  backgroundRed: '#FEEDED',
  nurtureBlue: '#1F84CD',
  backgroundAvatarActive: '#C8FBC590',
  backgroundAvatarDisabled: '#BDBDBD',
  backgroundBlue: '#EDF5FE',
  workingLightBlue: '#2AC7EA',
  backgroundLightBlue: '#EEFBFD',
  callScheduledGreen: '#0AD437',
  backgroundGreen: '#EEFDF1',
  customerYellow: '#FF9F2E',
  lightYellow: '#FFC000',
  backgroundYellow: '#FFF7EE',
  dialerBlue: '#1E394C',
  dialerBackground: '#F8F9FD',
  dialerGreen: '#6BCC92',
  placeholder: '#00000048',
  linkedin: '#0077B5',
  chart1: '#AC92EB',
  chart1Lightened: '#DFC5FF',
  chart2: '#4FC1E8',
  chart3: '#A0D568',
  chart3Lightened: '#EDFFB5',
  chart4: '#FFCE54',
  chart5: '#ED5564',
  success: '#00c851',
  workingAccount: '#1F84CD',
  recommendedColor: '#37FF2C',
  cellGrey: '#FAFBFC',
  actions: [
    '#1F84CD',
    '#FFCE54',
    '#B9DA7C',
    '#AC92EB',
    '#ED5564',
    '#000000',
    '#F1C63B',
    '#0000F6',
    '#00F700',
    '#F60000',
  ],
  linkedinAction: '#E8F3F1',
  newsAction: '#D1FAE8',
  findAction: '#e6f1f9',
  emailAction: '#FFF5F4',
  callAction: '#E5FFFC',
  searchProspectAction: '#feffef',
  searchAccountAction: '#FFF0FF',
  activateAction: '#efffe9',
  reminderAction: '#FFDCA940',

  //V2
  inactive: '#FD6778', // red-500
  inactiveHover: '#ED4C5E', // red-600
  inactiveLight: '#FFE2E2', // red-200
  inactiveExtraLight: '#FFF0F0',
  inactiveLightHover: '#FDD0D0', // red-300
  nurture: '#F9BB06', // yellow-500
  nurtureHover: '#E2AD13', // yellow-600
  nurtureLight: '#FEF3D2', // yellow-200
  nurtureLightHover: '#F8E6B1', // yellow-300
  prospecting: '#4E9AFF', // sky-500
  prospectingHover: '#3880DF', // sky-600
  prospectingLight: '#EAF1FB', // gray-200
  prospectingLightHover: '#D5E0F0', // gray-300
  callScheduled: '#24BA84', // green-500
  callScheduledHover: '#1A9D6E', // green-600
  callScheduledLight: '#E9F8F8', // primary-100
  callScheduledLightHover: '#CEEDED',
  openOpportunity: '#A35AFF', // purple-500
  openOpportunityHover: '#8846DC', // purple-600
  openOpportunityLight: '#F2EAFF', // purple-200
  openOpportunityLightHover: '#E4D8F6', // purple-300
  lightPink: '#F376D8', // pink-500
  lightPinkHover: '#E769CB', // pink-600
  transparentPink: '#FFEBFB',
  lightBlueHover: '#3B85E8', // sky-600
  transparentBlue: '#E1F2FF', // tag-2-2-100
  transparentBlueHover: '#BED7E9', // tag-2-2-200
  customer: '#F376D8', // pink-500
  customerHover: '#E769CB', // pink-600
  customerLight: '#FDE5F8', // pink-200
  customerLightHover: '#F3CEEB', // pink-300
  pastelGreen: '#E7F5D9',
  darkGreen: '#0A9B94', // primary-800
  darkGreenHover: '#10635F', // primary-900
  lightGreen: '#55B77B',
  activeScrollbarGreen: '#07c8c0',
  analyticsGreen: '#E5F4EB',
  intenseLightBlue: '#1E9EBA',
  intenseBlue: '#2C66B1', // sky-700
  intenseBlueChipBackground: '#E2EBF7',
  importFileError: '#FFEFEF',
  badgeBackground: '#EEF2F5',
  sequenceCardHover: '#f6faff', // gray-100
  repliedEmailLightGreen: '#DFF1E6',
  linkedinRepliedMessageLightBlue: '#EAF3FB', // sky-200
  lightBlueBackground: '#DDEAFB',
  popularPlanBadge: '#31ABA5',
  popularPlanGreen: '#1EBAB2', // primary-700
  ultraPlanDarkGreen: '#035C6B',
  ultraPlanDarkBlue: '#4E9AFF', // sky-500
  ultraPlanBadge: '#ceeded33',
  customPlanPurple: '#995AFF', // purple-500
  selectedOptionGrey: '#EAF1FB', // gray-200
  freeTrialYellow: '#FEF8E5',
  freeTrialDarkYellow: '#C69812', // yellow-700
  darkYellow: '#C69812', // yellow-700
  darkYellowHover: '#A37E10',
  lightGreenBlue: '#EAF3FB', // gray-200
  warningOrange: '#F9CCB5',
  warningOrangeLight: '#FFEBDD', // orange-200
  warningOrangeLightHover: '#FED6C4',
  white: '#ffffff', // white
  black: '#010E27', // gray-900
  mainDark: '#08193B',
  primary: '#1EBAB2', // primary-700
  primaryDark: '#1EA59E',
  primaryDarkHover: '#17827B',
  primaryLight: '#E9F8F8', // primary-100
  primaryLightHover: '#CEEDED',
  primaryLightHoverHover: '#D7F0F0',
  primaryLightBackground: '#F4FCFB',
  placeholderGrey: '#F5F7FB', // neutral-100
  featureOnboardingHover: '#D9F1F1',

  closeRed: '#fd6878', // red-500
  backgroundCloseRed: '#ffe2e1', // red-200
  backgroundSaveGreen: '#e7f8f7',

  purple: '#A35AFF', // purple-500
  purpleHover: '#8846DC', // purple-600
  purpleLight: '#F2EAFF', // purple-200
  purpleLightHover: '#E4D8F6', // purple-300
  purpleLight2: '#995AFF', // purple-500

  blue: '#5370F6',
  blueHover: '#3B58DB', // blue-600
  blueLight: '#EAF1FB', // gray-200
  blueLightHover: '#D5E0F0', // gray-300
  blueLinkedIn: '#0077B5',

  orange: '#FD8267',
  orangeDark: '#E46935', // orange-700
  orangeLight: '#FFEBDD', // orange-200
  orangeLightHover: '#FFD8C7',

  green: '#1A9D6E', // green-600
  greenLight: '#DFF1E6',
  greenLightHover: '#C3E5D1',
  greenLight2: '#E5F5EB',
  green200: '#DCF1EB', // green-200

  grey1: '#3E485B', // neutral-800
  grey11: '#7A8395', // gray-700
  grey2: '#AFB5BF', // neutral-500
  grey3: '#D0DCED',
  grey33: '#D7DCEB', // neutral-400
  grey4: '#EAF1FB', // gray-200
  grey44: '#E4E7EB',
  grey444: '#E6E9F2', // neutral-300
  grey4Hover: '#D5E0F0', // gray-300
  grey55: '#EAF1FB', // gray-200
  grey5: '#E4E5E8',
  grey6: '#F5F7F9', // neutral-100
  grey600: '#A0A9BC', // gray-600
  grey66: '#EEF7FF',
  greyGreenLight: '#EDF9F9',
  greyHover: '#f6f9ff', // gray-100
  greyLight: '#FAFCFF',
  greyButtonHoverLight: '#010E27cc',
  greyOptionHover: '#f1f7ff', // neutral-200
  inboxBackground: '#f1f4f7', // neutral-200
  buttonGrayHover: '#747B88',
  tableHover: '#f8fbff',
  hubspotColor: '#FF5C35', // hubspot
  hubspotOrange: '#FF7A59',
  salesforceColor: '#22A0E0',
  salesforceBlue: '#20A0DF', // salesforce
  lightBlue: '#DEECFF', // tag-2-3-100
  pipedriveColor: '#017737', // pipedrive
  chartMogulColor: '#15324C',
  attioColor: '#202124',
  zohoColor: '#F5F7F9',
  dynamicsColor: '#F5F7F9',
  greyExpandButton: '#E3EFFF',
  greyHoverNote: '#F4F8FF',
  greyButtonHover: '#BFCDE1', // gray-500
  greySelectBorder: '#dadde9',
  greySelectBorder2: '#C3C3C3',
  greySelectBoxShadow: '#0000001a',
  greyBackgroundScheduled: '#E9ECF3',
  greyFieldBorder: '#cdcdcd',
  greyIconCompletedTask: '#8AA0BF',
  greyScrollbarBg: '#d7dceb', // neutral-400
  nullStatusBackground: '#E6E9F2', // neutral-300
  nullStatusText: '#7A8395', // gray-700

  openTrackCountColor: '#D7F1FA', // tag-2-1-100
  // Insight colors
  profileViewLight: '#faf6ff',
  socialPresenceLight: '#ebf7ff',
  keyTopicsLight: '#fef7e0',
  jobOpeningsLight: '#feedfa',
  companyNewsLight: '#eef8e3',
  fundingRounds: '#FFEFE3',

  socialPresenceIcon: '#bbe2fe',
  companyNewsIcon: '#d3e9bc',
  fundingRoundsIcon: '#FED6C2',

  socialPresenceCounter: '#53b5fc', // tag-2-2-300
  companyNewsCounter: '#8ac051',
  fundingRoundsCounter: '#FD9467', // tag-3-3-300

  //Analytics on extension
  inStrategyCompaniesMain: '#536DE5',
  inStrategyCompaniesLight: '#ced5f6',

  completedTasksMain: '#60A54F',
  completedTasksLight: '#E8F5D9',

  errorTasksMain: '#FD6778', // red-500
  errorTasksLight: '#FFE9E9',

  mostConvertedLabel: '#3EA768', // tag-1-6-300

  templatesPurple: '#D4BFFF', // purple-400
  templatesPurpleHover: '#c3a7fc',

  templatesBlue: '#3B85E8', // sky-600
  templatesBlueHover: '#0B66C2',
  templatesIconBlue: '#ABD1FF', // sky-400
  templatesIconBlueHover: '#3B85E8', // sky-600
  secondaryTagBorder: '#BED5E5', // tag-2-2-200

  insightsYellow: '#FFD748', // yellow-400
  insightsYellowHover: '#edc32d',

  rewriteWithAILightBlue: '#BFDCFF',
  rewriteWithAILightBlueHover: '#8dafd9',

  automaticTasksTooltipBackground: '#E4E8F9',

  localTimeBadgeBackground: '#e6eef8',

  //Find phone credits color
  findPhoneCredits: '#C69812', // yellow-700
  findPhoneCreditsLight: '#FEF3D2', // yellow-200
  findPhoneCreditsLightHover: '#F8E6B1', // yellow-300

  rewriteCredits: '#8846DC', // purple-600
  rewriteCreditsLight: '#F2EAFF ', // purple-200
  rewriteCreditsBackground: '#D4BFFF', // purple-400
  rewriteCreditsBackgroundHover: '#C4AEF1',
  primaryHover: '#BEE6E5', // primary-300
  dsGray800: '#4b5975', // gray-800
  // Tag colors
  firstTagLight: [
    '#FFF5C9', // tag-1-1-100
    '#F6F7C1', // tag-1-2-100
    '#EDF7C8', // tag-1-3-100
    '#E0F2CD', // tag-1-4-100
    '#D5ECCF', // tag-1-5-100
    '#D3EEDD',
    '#CEEFE3', // tag-1-7-100
    '#D4E6CE', // tag-1-8-100
    '#DEE6CA', // tag-1-9-100
    '#E9E2C2', // tag-1-10-100
    '#DFDAC5', // tag-1-11-100
    '#D8D6CE', // tag-1-12-100
  ],
  firstTagLightHover: [
    '#E5DCB5', // tag-1-1-200
    '#DDDEAE', // tag-1-2-200
    '#D5DEB4', // tag-1-3-200
    '#CADAB8', // tag-1-4-200
    '#C0D4BA', // tag-1-5-200
    '#BED6C7', // tag-1-6-200
    '#B9D7CC', // tag-1-7-200
    '#BFCFB9', // tag-1-8-200
    '#C8CFB6', // tag-1-9-200
    '#D2CBAF', // tag-1-10-200
    '#C9C4B1', // tag-1-11-200
    '#C2C1B9', // tag-1-12-200
  ],
  firstTag: [
    '#F0C62F', // tag-1-1-300
    '#B4B662', // tag-1-2-300
    '#A8C052', // tag-1-3-300
    '#71B161',
    '#3EA768', // tag-1-6-300
    '#3EA768', // tag-1-6-300
    '#0A9B78', // tag-1-7-300
    '#789C6D', // tag-1-8-300
    '#95A077', // tag-1-9-300
    '#AAA27F', // tag-1-10-300
    '#968D68', // tag-1-11-300
    '#7F7A66', // tag-1-12-300
  ],
  secondTagLight: [
    '#D7F1FA', // tag-2-1-100
    '#D3EDFF',
    '#DEECFF', // tag-2-3-100
    '#E4E4FF', // tag-2-4-100
    '#F2EAFF', // tag-2-5-100
    '#DFD1F1', // tag-2-6-100
    '#CBCBEB', // tag-2-7-100
    '#C1D4ED', // tag-2-8-100
    '#BED7E9', // tag-2-9-100
    '#C4E1EB', // tag-2-10-100
    '#CBE9EE', // tag-2-11-100
    '#D2E7E8', // tag-2-12-100
  ],
  secondTagLightHover: [
    '#C1D9E1', // tag-2-1-200
    '#BED5E5', // tag-2-2-200
    '#C8D4E5', // tag-2-3-200
    '#CDCDE5', // tag-2-4-200
    '#E4D8F6', // tag-2-5-200
    '#C9BCD9', // tag-2-6-200
    '#B7B7D3', // tag-2-7-200
    '#AEBFD5', // tag-2-8-200
    '#ABC1D2', // tag-2-9-200
    '#B0CAD3', // tag-2-10-200
    '#B7D2D6', // tag-2-11-200
    '#BDD0D1', // tag-2-12-200
  ],
  secondTag: [
    '#2DC2F1', // tag-2-1-300
    '#53B5FC', // tag-2-2-300
    '#4E9AFF', // tag-2-3-300
    '#826DFF',
    '#995AFF', // tag-2-5-300
    '#8960BD', // tag-2-6-300
    '#6E5DDD', // tag-2-7-300
    '#5073A2', // tag-2-8-300
    '#2974AB', // tag-2-9-300
    '#44869E', // tag-2-10-300
    '#2596AB', // tag-2-11-300
    '#498E92', // tag-2-12-300
  ],
  thirdTagLight: [
    '#FFE0FC', // tag-3-1-100
    '#FFE3F0', // tag-3-2-100
    '#FFE2E2', // tag-3-3-100
    '#FFEBDD', // tag-3-4-100
    '#FAEED7', // tag-3-5-100
    '#F4E4C6', // tag-3-6-100
    '#F3E0D3', // tag-3-7-100
    '#F1D7D5', // tag-3-8-100
    '#EED3DD',
    '#F2CEDE', // tag-3-10-100
    '#EDD2EB', // tag-3-11-100
    '#DFD0E3', // tag-3-12-100
  ],
  thirdTagLightHover: [
    '#E5CAE3', // tag-3-1-200
    '#E5CCD8', // tag-3-2-200
    '#E5CBCB', // tag-3-3-200
    '#E5D3C7', // tag-3-4-200
    '#E1D6C1', // tag-3-5-200
    '#DCCDB2', // tag-3-6-200
    '#DBCABE', // tag-3-7-200
    '#D9C1C0', // tag-3-8-200
    '#D6BEC7', // tag-3-9-200
    '#DAB9C8', // tag-3-10-200
    '#D5BDD3', // tag-3-11-200
    '#C9BBCC', // tag-3-12-200
  ],
  thirdTag: [
    '#E469E7', // tag-3-1-300
    '#FD67AF', // tag-3-2-300
    '#FD6778', // tag-3-3-300
    '#FD9467', // tag-3-4-300
    '#F7A253', // tag-3-5-300
    '#CAA050', // tag-3-6-300
    '#C28E6A', // tag-3-7-300
    '#BD6868', // tag-3-8-300
    '#A5607A', // tag-3-9-300
    '#AB5079', // tag-3-10-300
    '#A76AA3', // tag-3-11-300
    '#8D6090', // tag-3-12-300
  ],
};
export const theme = createTheme({
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
  palette: {
    primary: {
      main: colors.primary,
      light: colors.primaryLight,
      dark: colors.primaryDark,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.black,
      contrastText: colors.white,
    },
  },
});

theme.components = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
  },
  MuiTextField: {
    defaultProps: {
      autoComplete: 'off',
      'aria-autocomplete': 'none',

      InputProps: {
        autoComplete: 'off',
        'aria-autocomplete': 'none',
      },
    },
  },
  MuiInput: {
    defaultProps: {
      autoComplete: 'off',
      'aria-autocomplete': 'none',
    },
  },
  MuiInputBase: {
    defaultProps: {
      autoComplete: 'off',
      'aria-autocomplete': 'none',
    },
  },
  //Not working
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: '#151618',
      },
      arrow: {
        color: '#151618',
      },
    },
  },
};
